import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { AddNewFooter } from '@/components/add-new-footer';
import { CollectionOptionType } from '@/hooks/use-collection-list-options';
import { createStyles } from '@/contexts/theme-context';
import { List } from '@/components/list';
import { ListItemSeparator } from '@/components/list-item';
import { OrderGuideCollectionListItemContent } from './order-guide-collection-list-item-content';

interface Props {
  collectionData: CollectionOptionType[];
  /** Omit to render the list without the "New order guide" footer. */
  onCreate?: () => void;
  onSelect: (collectionUUID: string) => void;
  selectedCollectionUUID?: string;
}

export const OrderGuideCollectionList: React.FC<Props> = ({
  collectionData,
  onCreate,
  onSelect,
  selectedCollectionUUID,
}) => {
  const [styles] = useStyles();
  return (
    <List<CollectionOptionType>
      data={collectionData}
      ListFooterComponent={
        onCreate
          ? () => (
              <>
                <ListItemSeparator />
                <AddNewFooter
                  onSelect={() => {
                    Analytics.track(
                      'order_guide_list_action_sheet.order_guide_collection_create.press',
                    );

                    onCreate();
                  }}
                  size="small"
                  title={i18n.t('new_order_guide')}
                />
              </>
            )
          : undefined
      }
      listItemStyle={(option) =>
        selectedCollectionUUID && option.value === selectedCollectionUUID
          ? styles.listItemSelected
          : null
      }
      onSelect={(option) => {
        const collectionUUID = String(option.value);
        Analytics.track(
          'order_guide_list_action_sheet.order_guide_collection.select',
          { collectionUUID },
        );

        onSelect(collectionUUID);
      }}
      renderMainContent={(option) => (
        <OrderGuideCollectionListItemContent option={option} />
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  listItemSelected: {
    backgroundColor: theme.colors.accentLight,
  },
}));
